export const urls = {
  root: "/",
  incidents: "/incidents",
  incidentDetail: (id: number | string) => `/incidents/${id}`,
  reportIncident: "/report",
  designSystem: "/design-system",
  auth: {
    login: "/auth/login",
  },
} as const;
